import React, {useEffect, useState} from 'react';

// bootstrap
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

// custom components
import { Backbutton } from '_molecules';

// tremor
import { Title as TremorTitle, Subtitle } from '@tremor/react';

// styling
import { Spacing, Typography, Colors } from '_styles';

const IconPageTitle = (props) => {

    return (
        <Row style={{ display:'flex' }}>
            <Col xs={2}>
                <Backbutton rowCenter={true} onClick={props.back} />
                <div style={{ justifyContent:'center', alignItems:'center', textAlign:'center'}} className='mt-2'>
                    { props.icon }
                </div>
            </Col>
            <Col style={{  }}>
                <p style={{ fontWeight:'bold', color: Colors.PRM_LIGHT_BLUE, fontSize:14, marginBottom:-Spacing.SCALE_4}}>{props.topText}</p>
                <p style={{
                    fontSize:28, fontWeight:'bold', marginBottom:-Spacing.SCALE_2
                }}>{props.title}</p>
                <Subtitle>{props.subtitle}</Subtitle>
            </Col>
        </Row>
    );
};

export default IconPageTitle;
